import { type MetaFunction } from '@remix-run/node'
import productWorkersCompensation from './product-workerscompensation.png'

export const meta: MetaFunction = () => [
	{ title: "Worker's Compensation Insurance" },
	{
		name: 'description',
		content: "We offer insurance for workers' compensation.",
	},
]

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<h1 className="py-3 text-4xl font-black">Workers' Compensation</h1>

			<img
				src={productWorkersCompensation}
				alt="A medical provider examining a patient's hand"
				className="rounded-lg object-cover object-center"
			/>

			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Workers' compensation insurance is a type of insurance that provides
				medical benefits and wage replacement to employees who are injured on
				the job. It is a mandatory insurance coverage for most employers in the
				United States, and it is designed to protect both employees and
				employers in the event of a workplace injury.
			</p>

			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				We understand the importance of workers' compensation insurance for both
				employees and employers. We offer a variety of workers' compensation
				insurance options to meet the unique needs of every business, from small
				family-owned businesses to large corporations. Our experienced agents
				will work with you to find the right coverage for your business at a
				price that fits your budget.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Contact us today to learn more about our workers' compensation insurance
				options and how we can help protect your business and your employees.
			</p>
		</main>
	)
}
